import { useCallback } from "react";
import { parseErrorDetails, generateErrorMessage } from "../utils/errorUtils";

interface ErrorDetail {
  loc: (string | number)[];
  msg: string;
}

interface FastApiErrorResponse {
  detail?: ErrorDetail[];
}

export interface ErrorResponse {
  response?: {
    data?: {
      message?: string;
    };
    status?: number;
  };
  request?: any;
  message?: string;
  detail?: ErrorDetail[];
  // формат ошибок гейтвея: { message, errors?: [{ path, message }], traceId }
  errors?: { path: string; message: string }[];
  traceId?: string;
}

const useErrorHandling = () => {
  const handleError = useCallback(
    (
      error: ErrorResponse,
    ): {
      parsedErrors?: { field: string; message: string }[];
      errorMessage: string;
    } => {
      if (error.traceId || error.errors) {
        const fields = error.errors || [];
        const details = fields
          .map((e) => `${e.path} - ${e.message}`)
          .join("; ");

        return {
          parsedErrors: fields.map((e) => ({
            field: e.path,
            message: e.message,
          })),
          errorMessage: [
            error.message || "Ошибка запроса",
            details,
            error.traceId && `traceId: ${error.traceId}`,
          ]
            .filter(Boolean)
            .join(" · "),
        };
      }

      if (error.detail) {
        const parsedErrors = parseErrorDetails(error as FastApiErrorResponse);
        const errorMessage = generateErrorMessage(
          error as FastApiErrorResponse,
        );
        return {
          parsedErrors,
          errorMessage,
        };
      }

      if (error.response) {
        if (error.response.data && error.response.data.message) {
          return { errorMessage: error.response.data.message };
        }
        return { errorMessage: `Серверная ошибка: ${error.response.status}` };
      } else if (error.request) {
        return { errorMessage: "Нет ответа от сервера" };
      } else {
        return { errorMessage: error.message || "Неизвестная ошибка" };
      }
    },
    [],
  );

  return handleError;
};

export default useErrorHandling;
